export { default as useMiniSearch } from "./useMiniSearch";
